import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

let cache = null;
function loadUoms() {
  if (!cache) cache = api.get("/masters/uom").then(({ data }) => (data || []).filter((u) => u.is_active !== false)).catch(() => []);
  return cache;
}

/** Dropdown of units from Masters → Units of Measure. Value is the unit code (e.g. "NOS", "M3"). */
export function UomSelect({ value, onChange, className, testId }) {
  const [uoms, setUoms] = useState([]);
  useEffect(() => { loadUoms().then(setUoms); }, []);
  const known = uoms.some((u) => u.code === value);
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
      <SelectTrigger className={className} data-testid={testId}><SelectValue placeholder="Select unit" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">—</SelectItem>
        {value && !known && <SelectItem value={value}>{value}</SelectItem>}
        {uoms.map((u) => <SelectItem key={u.id} value={u.code}>{u.code}{u.name && u.name !== u.code ? ` — ${u.name}` : ""}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
